export const errorMessage = 'Bez wyrażenia tych zgód nie możemy przyjąć Twojego zgłoszenia'
export const label = 'Zaznacz wszystkie zgody'
